import { styled } from '@mui/material/styles'
import { TextField, TextFieldProps } from '@mui/material'
import { useState } from 'react'

export const StyleInput = styled(TextField)({
    width: '100%',
    fontSize: 14,

    '.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input': {
        height: '1rem',
    },

    '.MuiInputBase-adornedStart': {
        gap: '0.3rem',
    },

    '& label': {
        fontFamily: 'Open Sans',
        fontSize: '14px',
        marginLeft: '0.15rem',
    },
    '& label.Mui-focused': {
        color: '#A69478',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#707070',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#A69478',
        },
    },

    '& .MuiInputBase-input': {
        fontSize: '14px',
    },
})

type InputCustomTypes = {
    onInputCallBack?: (value: string) => void,
    delayInputCallback?: number
}

export type InputFormProps = TextFieldProps & InputCustomTypes

export function InputForm(props: InputFormProps): JSX.Element {
    const materialProps: InputFormProps = { ...props }
    delete materialProps.onInputCallBack
    delete materialProps.delayInputCallback

    const [timeoutSearch, setTimeoutSearch] = useState<NodeJS.Timeout>()
    return (
        <>
            <StyleInput {...materialProps} onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                if (props.onInput)
                    props.onInput(event)
                clearTimeout(timeoutSearch)
                setTimeoutSearch(() => {
                    return setTimeout(() => {
                        if (props.onInputCallBack) {
                            props.onInputCallBack(event.target.value)
                        }
                    }, props.delayInputCallback ?? 500)
                })
            }}
            />
        </>
    )
}
